// extracted by mini-css-extract-plugin
export default {"reportName":"style--reportName--2cf9d2","salonName":"style--salonName--495abc","row":"style--row--96e82b","actionButtons":"style--actionButtons--21b621"};